module.exports = __webpack_public_path__ + "img/敲打.af5f7433.png";